import { CSuiteBaseService } from "./CSuiteBaseServices";

class CompanyService extends CSuiteBaseService {
  getAllMarketCap = () => {
    return this.get(`company/get-all-marketcap`);
  };

  // getAllCompanies = () => {
  //   return this.get(`company/get-all-companies`);
  // };

  // getAllExecutives = () => {
  //   return this.get(`executive/get-all-executives`);
  // };

  getExecutivesFromCompany = (ticker) => {
    return this.get(`executive/get-executives?ticker=${ticker}`);
  };

  getMarketCap = (ticker) => {
    return this.get(`company/get-marketcap?ticker=${ticker}`);
  };

  getMonthlyReturns = (tickers, token) => {
    return this.post(`company/get-monthly-returns?token=${token}`, tickers);
  };

  getWeeklyReturns = (tickers, token) => {
    return this.post(`company/get-weekly-returns?token=${token}`, tickers);
  };

  getDailyPrices = (tickers, token) => {
    return this.post(`company/get-daily-prices?token=${token}`, tickers);
  };

  getTreasuryYields = (dates, token) => {
    return this.get(
      `company/get-treasury-yields?dates=${dates}&token=${token}`,
    );
  };

  getCompensationDecisions = (tickers, reportYear, token) => {
    return this.post(
      `company/get-compensation-decisions?reportYear=${reportYear}&token=${token}`,
      tickers,
    );
  };

  getChangeInControls = (tickers, reportYear, token) => {
    return this.post(
      `company/get-change-in-controls?reportYear=${reportYear}&token=${token}`,
      tickers,
    );
  };

  getAwards = (tickers, reportYear, token) => {
    return this.post(
      `company/get-awards?reportYear=${reportYear}&token=${token}`,
      tickers,
    );
  };

  getRiskFactors = (tickers, reportYear, token) => {
    return this.post(
      `company/get-risk-factors?reportYear=${reportYear}&token=${token}`,
      tickers,
    );
  };

  getPlanBasedAwards = (tickers, reportYear, token) => {
    return this.post(
      `company/get-plan-based-awards?reportYear=${reportYear}&token=${token}`,
      tickers,
    );
  };

  getBoardPayStructure = (tickers, reportYear, token) => {
    return this.post(
      `company/get-board-pay-structure?reportYear=${reportYear}&token=${token}`,
      tickers,
    );
  };

  getExecutivePerks = (tickers, reportYear, token) => {
    return this.post(
      `company/get-executive-perks?reportYear=${reportYear}&token=${token}`,
      tickers,
    );
  };

  getVotingOutcomes = (tickers, token) => {
    return this.post(`company/get-voting-outcomes?token=${token}`, tickers);
  };

  getOptionsAssumptions = (tickers, token) => {
    return this.post(`company/get-options-assumptions?token=${token}`, tickers);
  };

  getEquityPoolUsage = (tickers, reportYear, token) => {
    return this.post(
      `company/get-equity-pool-usage?reportYear=${reportYear}&token=${token}`,
      tickers,
    );
  };

  getTotalDirectComp = (tickers, reportYear, token) => {
    return this.post(
      `company/get-total-direct-comp?reportYear=${reportYear}&token=${token}`,
      tickers,
    );
  };

  getFiscalData = (
    dataType,
    tickers,
    CIKs,
    periodType,
    fiscalYearNeeded,
    currency,
    latest,
    token,
  ) => {
    return this.get(
      `company/get-company-financial-data?dataType=${dataType}&tickers=${tickers}&CIKs=${CIKs}&periodType=${periodType}&fiscalYearNeeded=${fiscalYearNeeded}&currency=${currency}&latest=${latest}&token=${token}`,
    );
  };

  getFiscalStockPrice = (
    dataType,
    tickers,
    CIKs,
    periodType,
    fiscalYearNeeded,
    currency,
    latest,
    token,
  ) => {
    return this.get(
      `company/get-company-financial-data?dataType=${dataType}&tickers=${tickers}&CIKs=${CIKs}&periodType=${periodType}&fiscalYearNeeded=${fiscalYearNeeded}&currency=${currency}&latest=${latest}&token=${token}`,
    );
  };

  getCompanyProfile = (tickers, CIKs, token) => {
    return this.get(
      `company/get-company-profiles?tickers=${tickers}&ciks=${CIKs}&token=${token}`,
    );
  };

  getMonthlyMarketcaps = (tickers, token) => {
    return this.post(`company/get-monthly-marketcaps?token=${token}`, tickers);
  };

  getBoardPay = (ticker, token) => {
    return this.post(`company/get-board-pay?token=${token}`, ticker);
  };

  getBoardPayProfiles = (ticker, token) => {
    return this.get(
      `company/get-board-pay-profiles?ticker=${ticker}&token=${token}`,
    );
  };

  getExecutiveProfiles = (ticker, token) => {
    return this.get(
      `company/get-executive-profiles?ticker=${ticker}&token=${token}`,
    );
  };

  getAllBoardPay = (token) => {
    return this.get(`company/get-all-board-pay?token=${token}`);
  };

  getIndexMonthlyReturns = (token) => {
    return this.get(`company/get-monthly-index-returns?token=${token}`);
  };

  getMedianByYear = (year) => {
    return this.get(`company/get-median-pay-from-year?year=${year}`);
  };

  getParagraphsFrom8k502 = (ticker) => {
    return this.get(`company/get-paragraphs-from-8k502?ticker=${ticker}`);
  };

  compAISearch = (searchParams, token) => {
    return this.post(`company/comp-ai-search?token=${token}`, searchParams);
  };

  compAIAvailability = (ticker, token) => {
    return this.post(`company/comp-ai-availability?token=${token}`, ticker);
  };

  compAIResultRating = (ratingDetails, token) => {
    return this.post(
      `company/comp-ai-result-rating?token=${token}`,
      ratingDetails,
    );
  };
}

export default new CompanyService();
